import React from 'react';

function Unauthorized(props) {
	return (
		<div className="container main">
			<div className="heading mt-4">Unauthorized</div>
			<div className="mt-2 mb-4">
				<p>You are not authorized to view this page. Please return to the home page.</p>
			</div>
		</div>
	);
}

export default Unauthorized;